/**
 * Session hint after POST /ratings/ succeeds so the UI hides "Rate" immediately
 * before the next GET reflects viewer_has_submitted_rating.
 */

const KEY_PREFIX = 'cmp_viewer_rated_deal_';

export function markViewerRatedDeal(dealId) {
  if (typeof window === 'undefined') return;
  sessionStorage.setItem(KEY_PREFIX + String(dealId), '1');
}

export function hasViewerRatedHint(dealId) {
  if (typeof window === 'undefined') return false;
  return sessionStorage.getItem(KEY_PREFIX + String(dealId)) === '1';
}

export function clearViewerRatedHint(dealId) {
  if (typeof window === 'undefined') return;
  sessionStorage.removeItem(KEY_PREFIX + String(dealId));
}

/** True if API says rated or we just submitted in this tab (session hint). */
export function viewerHasRated(dealOrRow, dealId) {
  const id = dealId != null ? dealId : dealOrRow?.id;
  const fromApi = dealOrRow?.viewer_has_submitted_rating === true;
  return Boolean(fromApi || (id != null && hasViewerRatedHint(id)));
}
